export default __webpack_public_path__ + "static/media/recurring-img1.e64061ad.svg";